import { createSlice } from "@reduxjs/toolkit";
import {
  ColumnOrderState,
  ColumnSizingState,
  ColumnSort,
  VisibilityState,
} from "@tanstack/react-table";

export enum TableSize {
  S = "sm",
  M = "md",
}

export enum PerPage {
  Twenty = "20",
  Fifty = "50",
  Hundred = "100",
}

type InitialState = {
  columnVisibility: VisibilityState | undefined;
  columnSizing: ColumnSizingState | undefined;
  sorting: ColumnSort[];
  tableSize: TableSize;
  perPage: PerPage;
  columnOrder: ColumnOrderState;

  isReady: boolean;
};

const initialState: InitialState = {
  columnVisibility: {},
  columnSizing: {},
  sorting: [],
  tableSize: TableSize.M,
  perPage: PerPage.Twenty,
  columnOrder: [
    "id",
    "booking_status_id",
    "ticket_status_id",
    "invoice_status_id",
    "booking_reference",
    "ordered_at",
    "departure_date",
    "departure_time",
    "arrival_date",
    "arrival_time",
    "departure_country",
    "arrival_country",
    "route_code",
    "customer_reference",
    "vehicle_number",
    "trailer_number",
    "vehicle_type_id",
    "trailer_type_id",
    "cargo_type_id",
    "plug_in",
    "adr",
    "created_by",
  ],

  isReady: false,
};

const bookingSettingSlice = createSlice({
  name: "bookingSettingSlice",
  initialState,
  reducers: {
    setColumnVisibility: (state, action) => {
      state.columnVisibility = {
        ...state.columnVisibility,
        ...action.payload,
      };
    },
    setColumnSizing: (state, action) => {
      state.columnSizing = {
        ...state.columnSizing,
        ...action.payload,
      };
    },
    setSorting: (state, action) => {
      const newSort: ColumnSort = action.payload[0];
      const existed = state.sorting.find((sort) => sort.id === newSort.id);

      state.sorting = existed && !newSort.desc ? [] : action.payload;
    },
    setTableSize: (state, action) => {
      state.tableSize = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setColumnOrder: (state, action) => {
      state.columnOrder = action.payload;
    },
    setReady: (state, action) => {
      state.isReady = action.payload;
    },
    reset: () => initialState,
  },
});

export default bookingSettingSlice;
